// currency/actions.js
import setHeader from "../../../components/Functions/setHeader";
import instance from "../../../services/axiosConfig";

// Action Types
export const FETCH_CURRENCY_REQUEST = "FETCH_CURRENCY_REQUEST";
export const FETCH_CURRENCY_SUCCESS = "FETCH_CURRENCY_SUCCESS";
export const FETCH_CURRENCY_FAILURE = "FETCH_CURRENCY_FAILURE";

// Action Creators
export const fetchCurrencyRequest = () => ({
    type: FETCH_CURRENCY_REQUEST,
});

export const fetchCurrencySuccess = (currencies) => ({
    type: FETCH_CURRENCY_SUCCESS,
    payload: currencies,
});

export const fetchCurrencyFailure = (error) => ({
    type: FETCH_CURRENCY_FAILURE,
    payload: error,
});

// Thunk for fetching active currencies
export const fetchActiveCurrencies = () => {
    return async (dispatch) => {
        
        dispatch(fetchCurrencyRequest());
        try {
            const res = await instance.get("currency-list",setHeader()); // adjust endpoint if needed

            const allCurrencies = res.data?.data || []; // array inside "data"
            const activeCurrencies = allCurrencies.filter(
                (item) => item.active_status === "1"
            );

            dispatch(fetchCurrencySuccess(activeCurrencies[0]));
        } catch (error) {
            dispatch(fetchCurrencyFailure(error.message || "Something went wrong"));
        }
    };
};
